// Module
var code = "<h1 id=formrender-表单渲染器>FormRender 表单渲染器</h1> <p>数据驱动表单。</p> <p>使用json配置表单。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>查询条件。</li> <li>新增、编辑。</li> <li>详情。</li> </ul> <p>配置信息请参考 <code>package/components/form-render/type</code></p> ";
// Exports
module.exports = code;